import { type ReactNode } from 'react'
import { Header } from './Header';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();

  // Definimos en qué rutas NO queremos mostrar el Header
  const hideHeaderRoutes = ['/form'];
  const shouldShowHeader = !hideHeaderRoutes.includes(location.pathname);
  
  return (
    <div className="d-flex dashboard">
      <div className="content">
          {/* Renderizado condicional del Header */}
          {shouldShowHeader && <Header />}

            {/* Main Content */}
            <span className="content">

              <span className="udsp_default">
                {/*<div pantalla="CONTENIDO">*/}
                {children}
              </span>

            </span>
      </div>
    </div>
  )
}